import type { ExecutionChatMessageRow } from '@shared/types/execution-chat';

const compareByCreatedAtThenId = (
  a: Pick<ExecutionChatMessageRow, 'created_at' | 'id'>,
  b: Pick<ExecutionChatMessageRow, 'created_at' | 'id'>,
): number => {
  if (a.created_at < b.created_at) return -1;
  if (a.created_at > b.created_at) return 1;
  if (a.id < b.id) return -1;
  if (a.id > b.id) return 1;
  return 0;
};

export const sortExecutionChatMessages = (
  rows: ExecutionChatMessageRow[],
): ExecutionChatMessageRow[] => [...rows].sort(compareByCreatedAtThenId);

